import { Command } from '@ckeditor/ckeditor5-core';
export default class InsertTemplateSliderCommand extends Command {
    execute() {
        this.editor.model.change((writer) => {
            this.editor.model.insertContent(createTemplateSlider(writer));
        });
    }
    refresh() {
        this.isEnabled = true;
    }
}
function createTemplateSlider(writer) {
    const templateSlider = writer.createElement('templateSlider');
    const templateSliderCaption = writer.createElement('templateSliderCaption');
    writer.append(templateSliderCaption, templateSlider);
    return templateSlider;
}
